const service = ((d) => {
  // Show page preloader
  const show = (text) => {
    d.getElementById("pagePreloader").style.display = "block";
    d.getElementById("pagePreloaderText").innerHTML = text && typeof text === "string" ? text + "..." : "";
  };

  // Hide page preloader
  const hide = () => {
    d.getElementById("pagePreloader").style.display = "none";
  };

  // Show chart preloader
  const showChartLoader = (whiteboardIndex, text) => {
    d.getElementById("chartPreloader-" + whiteboardIndex) ? d.getElementById("chartPreloader-" + whiteboardIndex).style.display = "block" : null;
    d.getElementById("chartPreloaderText-" + whiteboardIndex) ? d.getElementById("chartPreloaderText-" + whiteboardIndex).innerHTML = text && typeof text === "string" ? text + "..." : "" : null;
  };

  // Hide chart preloader
  const hideChartLoader = (whiteboardIndex) => {
    d.getElementById("chartPreloader-" + whiteboardIndex).style.display = "none";
  };

  return { show, hide, showChartLoader, hideChartLoader };
})(document);

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/page-preloader.js